/* FAQ View Styles */
.wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px clamp(16px, 4vw, 48px);
}

/* Header */
.header {
  margin-bottom: 24px;
}

.title {
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--foreground);
	margin: 0 0 8px;
}

.dark .title {
  color: var(--foreground);
}

.subtitle {
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin: 0;
}

.dark .subtitle {
  color: var(--muted-foreground);
}

/* Navigation Row */
.navRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 4px;
  flex-wrap: nowrap;
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.tab {
	padding: 8px 12px;
	border-radius: 20px;
	border: 1px solid var(--border);
	background: var(--secondary);
	color: var(--muted-foreground);
	font-size: 0.8125rem;
	font-weight: 500;
	cursor: pointer;
	white-space: nowrap;
	flex-shrink: 1;
	min-width: max-content;
	transition: all 0.2s;
}

.tab:hover {
  background: var(--secondary);
  color: var(--foreground);
}

.dark .tab {
  background: var(--secondary);
  border-color: var(--border);
  color: var(--muted-foreground);
}

.dark .tab:hover {
  background: var(--accent);
  color: var(--accent-foreground);
}

.tab.active {
  background: color-mix(in oklch, var(--primary) 10%, transparent);
  border-color: color-mix(in oklch, var(--primary) 30%, transparent);
  color: var(--primary);
}

.tab.active:hover {
  background: color-mix(in oklch, var(--primary) 15%, transparent);
  color: var(--primary);
}

.dark .tab.active {
  background: color-mix(in oklch, var(--primary) 20%, transparent);
  border-color: color-mix(in oklch, var(--primary) 40%, transparent);
  color: var(--primary);
}

/* Search */
.searchWrapper {
  position: relative;
  flex-shrink: 0;
  width: clamp(180px, 20vw, 300px);
}

.searchInput {
	width: 100%;
	padding: 12px 40px 12px 16px;
	border-radius: 8px;
	border: 1px solid var(--border);
	background: var(--background);
	color: var(--foreground);
	font-size: 0.875rem;
	outline: none;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;
}

.searchInput:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px color-mix(in oklch, var(--primary) 10%, transparent);
}

.searchInput::placeholder {
  color: var(--muted-foreground);
}

.dark .searchInput {
  background: var(--card);
  border-color: var(--border);
}

.dark .searchInput:focus {
  box-shadow: 0 0 0 3px color-mix(in oklch, var(--primary) 20%, transparent);
}

.dark .searchInput::placeholder {
  color: var(--muted-foreground);
}

.searchIcon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted-foreground);
  pointer-events: none;
}

.dark .searchIcon {
  color: var(--muted-foreground);
}

/* Content */
.content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resultsLabel {
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin-bottom: 8px;
}

.dark .resultsLabel {
  color: var(--muted-foreground);
}

/* Accordion */
.accordionItem {
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--background);
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.accordionItem:hover {
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 5%, transparent);
}

.dark .accordionItem {
  background: var(--card);
  border-color: var(--border);
}

.dark .accordionItem:hover {
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 20%, transparent);
}

.question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: none;
  background: var(--surface-1);
  text-align: left;
  cursor: pointer;
  gap: 12px;
  transition: background-color 0.2s;
}

.question:hover {
  background: var(--accent);
}

.dark .question {
  background: var(--card);
  color: var(--foreground);
}

.dark .question:hover {
  background: var(--accent);
}

.questionText {
	font-size: 0.875rem;
	font-weight: 500;
	color: var(--foreground);
	flex: 1;
	padding-right: 16px;
}

.dark .questionText {
  color: var(--foreground);
}

.categoryBadge {
	font-size: 0.75rem;
	font-weight: 500;
	padding: 2px 8px;
	border-radius: 4px;
	background: var(--muted);
	color: var(--muted-foreground);
	margin-left: 8px;
}

.dark .categoryBadge {
  background: var(--muted);
  color: var(--muted-foreground);
}

.chevron {
  width: 20px;
  height: 20px;
  color: var(--muted-foreground);
  transition: transform 0.2s;
  flex-shrink: 0;
}

.chevron.open {
  transform: rotate(180deg);
}

.dark .chevron {
  color: var(--muted-foreground);
}

.answer {
	padding: 16px;
	font-size: 0.875rem;
	line-height: 1.6;
	color: var(--foreground);
	background: var(--background);
	border-top: 1px solid var(--border);
	white-space: pre-wrap;
}

.dark .answer {
  color: var(--foreground);
  background: var(--background);
  border-top-color: var(--border);
}

/* FAQ Images */
.inlineImg {
  display: inline-block;
  height: 1.4em;
  width: auto;
  vertical-align: middle;
  margin: 0 4px;
  border-radius: 3px;
}

.dark .inlineImg {
  filter: brightness(0.9);
}

.blockImg {
  display: block;
  max-width: 400px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 10%, transparent);
}

.dark .blockImg {
  border-color: var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 30%, transparent);
}

.smallImg {
  display: block;
  max-width: 250px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 10%, transparent);
}

.dark .smallImg {
  border-color: var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 30%, transparent);
}

.lgBlockImg {
  display: block;
  max-width: 100%;
  width: 700px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 10%, transparent);
}

.dark .lgBlockImg {
  border-color: var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 30%, transparent);
}

.sideImg {
  display: inline-block;
  max-width: 45%;
  width: 300px;
  height: auto;
  margin: 8px;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 10%, transparent);
  vertical-align: middle;
}

.dark .sideImg {
  border-color: var(--border);
  box-shadow: 0 2px 8px color-mix(in oklch, var(--brand-950) 30%, transparent);
}

/* No Results */
.noResults {
  text-align: center;
  padding: 48px 24px;
  color: var(--muted-foreground);
}

.noResults svg {
  margin-bottom: 16px;
  opacity: 0.3;
}

.noResults p {
	font-size: 1rem;
	font-weight: 500;
	margin: 0 0 4px;
}

.noResults span {
	font-size: 0.875rem;
}

.dark .noResults {
  color: var(--muted-foreground);
}

/* Video Cards */
.videoGrid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.videoCard {
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--background);
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.videoCard:hover {
  box-shadow: 0 4px 12px color-mix(in oklch, var(--brand-950) 8%, transparent);
}

.dark .videoCard {
  background: var(--card);
  border-color: var(--border);
}

.dark .videoCard:hover {
  box-shadow: 0 4px 12px color-mix(in oklch, var(--brand-950) 30%, transparent);
}

.videoEmbed {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: var(--brand-950);
}

.videoEmbed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.videoCaption {
	padding: 12px 16px;
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin: 0;
	line-height: 1.5;
	background: var(--surface-1);
	border-top: 1px solid var(--border);
}

.dark .videoCaption {
  color: var(--muted-foreground);
  background: var(--card);
  border-top-color: var(--border);
}

/* Mobile */
@media (max-width: 768px) {
  .wrapper {
    padding: 24px 16px;
  }

	.title {
		font-size: 1.375rem;
	}

  .navRow {
    flex-direction: column;
    align-items: stretch;
  }

  .tabs {
    overflow-x: auto;
    padding-bottom: 8px;
  }

  .searchWrapper {
    width: 100%;
  }
}
